import React, { useEffect, useState } from 'react';
import { ToggleGroup, ToggleGroupItem } from '../../components/ui/toggle-group';
import { LayoutGrid, List } from 'lucide-react';

export type LayoutType = 'grid' | 'line';

interface LayoutToggleProps {
  onLayoutChange: (layout: LayoutType) => void;
  className?: string;
}

export const LayoutToggle: React.FC<LayoutToggleProps> = ({ 
  onLayoutChange,
  className
}) => {
  // Get the saved layout preference from localStorage or default to grid
  const [layout, setLayout] = useState<LayoutType>(() => {
    const savedLayout = localStorage.getItem('goodThingsLayoutPreference');
    return (savedLayout as LayoutType) || 'grid';
  });

  // Update the layout when the toggle is clicked
  const handleLayoutChange = (value: string) => {
    if (value === 'grid' || value === 'line') {
      setLayout(value as LayoutType);
      onLayoutChange(value as LayoutType);
      // Save the preference to localStorage
      localStorage.setItem('goodThingsLayoutPreference', value);
    }
  };

  // Initialize the layout on component mount
  useEffect(() => {
    onLayoutChange(layout);
  }, []);

  return (
    <ToggleGroup 
      type="single" 
      value={layout} 
      onValueChange={handleLayoutChange}
      className={className}
    >
      <ToggleGroupItem value="grid" aria-label="Grid Layout">
        <LayoutGrid className="h-4 w-4" />
      </ToggleGroupItem>
      <ToggleGroupItem value="line" aria-label="Line Layout">
        <List className="h-4 w-4" />
      </ToggleGroupItem>
    </ToggleGroup>
  );
};
